import React, { Component } from 'react';
import { FormGroup, Label, Row, Col, Input } from 'reactstrap';
import { Field } from 'redux-form/immutable';
import { renderSelectAnotherType, genericNormalizer, renderMultipleCheckBox } from './_FORM_FIELDS';
import { connect } from 'react-redux';
import { toJS } from '../../containers/to-js';
import { readAll } from '../../actions/workflow-item';
import PrintText from './PrintText';
import { ModelPropertiesParser, getNewContext, ModelPropertiesParserArray } from '../commons/modelPropertiesParser';
import { TypeModelDisplays } from '../../dto/type-model-displays';
import Table from './Table/Tablev1';
import { getModelByNamePromise } from '../../actions/workflows';
import TypeModelCreateUpdateTable from './TypeModelHelpers/TypeModelCreateUpdateTable';
import TypeModelBadges from './TypeModelHelpers/TypeModelBadges';
import RenderIcon from '../commons/RenderIcon';
import { Iterable } from 'immutable';
import resolvePath from '../../utils/resolvePath';
import TypeModelCreateUpdateWorkflowCard from './TypeModelHelpers/TypeModelCreateUpdateWorkflowCard';
import JSONPath from 'jsonpath';
import { filter } from 'lodash';
import {
  TABLE
} from './index';
import DataListStore from '../workflow/operations/filters/DataListStore';
import Pagination from '../commons/pagination';
import Items from '../menu/items/side-menu-items';

class TypeModelCreateUpdate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      model: null,
      isInitialValueSet: false,
      callCounter: 0,
      filter: [],
      showLoading: false
    }
  }
  componentDidMount() {
    const { isWorkflowCard, getModelByNamePromise, isLayoutItemEditable, customerName, workflow, containerIndex, isBase,
      layoutItem: { itemProperties: { showLoading, dontAllowAdditionDeletion, typeModelViewMode, recieveFieldsExtras, tableConfig, disbableOptimize, replaceClassProperty, readOnlyTableWithSelection, modelSelector, readOnlyTable, loadFilteredDataFromServer, parentModelSelector, field: { classProperty, customModelName } } } } = this.props;
    if (!loadFilteredDataFromServer && (!typeModelViewMode || typeModelViewMode.value != TypeModelDisplays.TABLE.value  || readOnlyTableWithSelection || readOnlyTable )) {
      this.setState({ callCounter: 1, showLoading: showLoading? true: false }, () => {
        if ((!parentModelSelector || isLayoutItemEditable)) {
          const existingCollection = this.props.typeModelCollection;

          const sessionId = workflow.sessionId || 'no-session';

          const readAllKey =
            `${workflow.id}_${customModelName}_${containerIndex}`;

          if (!window.readAllRequested) {
            window.readAllRequested = {};
          }

          if (!window.readAllSessionIds) {
            window.readAllSessionIds = {};
          }

          const hasExistingCollectionData =
            Array.isArray(existingCollection)
              ? existingCollection.length > 0
              : existingCollection &&
                Array.isArray(existingCollection.data) &&
                existingCollection.data.length > 0;

          const previousSessionId = window.readAllSessionIds[readAllKey];

          const isSameSession =
            previousSessionId === sessionId;

          // If collection already exists AND it belongs to the same session,
          // don't call getModelByNamePromise or readAll.
          if (
            hasExistingCollectionData &&
            isSameSession
          ) {
            this.setState({
              callCounter: 0,
              showLoading: false
            });
            return;
          }

          // If this is the same session and a request has already been made,
          // don't make another request.
          if (
            window.readAllRequested[readAllKey] &&
            isSameSession
          ) {
            this.setState({
              callCounter: 0,
              showLoading: false
            });
            return;
          }

          // Store the current session before making the API call.
          window.readAllRequested[readAllKey] = true;
          window.readAllSessionIds[readAllKey] = sessionId;

          !isWorkflowCard && getModelByNamePromise({ name: customModelName }).then((res) => {
            const model = res.data;
            const typeId = model.id;
            let recieveFields = ['id'];
            if(recieveFieldsExtras) {
              const splits = recieveFieldsExtras.split(',');
              recieveFields = recieveFields.concat(splits);
            }
            console.log(modelSelector)
            if(modelSelector) {
               const expression = new RegExp(/\{\{(.*?)\}\}/g);
                const val = modelSelector.replace(expression, (pattr, matched) => {
                  recieveFields.push(matched);
                })
            }
            if(tableConfig && tableConfig.config && tableConfig.config.columns) {
              const columns = tableConfig.config.columns;
              Array.isArray(columns) && columns.map((column, i) => {
                if(column.config && column.config.flyoutField  ) {
                const expression = new RegExp(/\{\{(.*?)\}\}/g);
                const val = column.config.flyoutField.replace(expression, (pattr, matched) => {
                      const columnKey = column.field.classProperty;
                  if(column.field.type === 'TYPE' && !columnKey.startsWith("$$SELF$$")){

                    const base = columnKey.replace(/[{}]/g, '');       // "funder"
                    const prop = matched.replace(/[{}]/g, '');         // "fundername"
                    const result = `${base}.${prop}`;              // "{{funder.fundername}}"
                    console.log(result)
                      recieveFields.push(result);
                  }else{
                    console.log(matched)
                    recieveFields.push(matched);
                  }
                })
              } else if(column.config &&  column.config.modelSelector ) {
                console.log("-====")
                const expression = new RegExp(/\{\{(.*?)\}\}/g);
                const val = column.config.modelSelector.replace(expression, (pattr, matched) => {
                  const columnKey = column.field.classProperty;
                  if(column.field.type === 'TYPE' && !columnKey.startsWith("$$SELF$$")){

                    const base = columnKey.replace(/[{}]/g, '');       // "funder"
                    const prop = matched.replace(/[{}]/g, '');         // "fundername"
                    const result = `${base}.${prop}`;              // "{{funder.fundername}}"
                    console.log(result)
                      recieveFields.push(result);
                  }else{
                    console.log(matched)
                    recieveFields.push(matched);
                  }
                
                })
              } else {
                console.log(column.field.classProperty)
                recieveFields.push(column.field.classProperty)
              }
              })  
            }
            const payload = {
              customModelName: customModelName,
              typeId,
              customerName,
              workflow: {
                id: workflow.id,
                displayMode: workflow.displayMode,
                // workflowSession: workflow.sessionId
              },

              showLoading: showLoading? true: false,
              isBase,
              "count": (readOnlyTableWithSelection || readOnlyTable) ? this.props.pageSize : 10000,
              "start": (readOnlyTableWithSelection || readOnlyTable) ? this.props.paginationStart : 0
            }
            if(recieveFields.length > 1 && !disbableOptimize) {
              payload['recieveFields'] = recieveFields;
            }
            this.props.readAll(payload, containerIndex);
            this.setState({ model, callCounter: 0, showLoading: false });
          })
        }
      })
    }

  }

  componentWillReceiveProps(nextProps) {
    const { isWorkflowCard, getModelByNamePromise, customerName, workflow, containerIndex, isBase, workflowData, columnIndex,
      layoutItem: { itemProperties: { recieveFieldsExtras, modelSelector, disbableOptimize, tableConfig, readOnlyTableWithSelection, readOnlyTable, loadFilteredDataFromServer, filterConfig, dontAllowAdditionDeletion, parentModelSelector, field: { classProperty, customModelName } } } } = nextProps;
    // if(nextProps.workflow && this.props.workflow && nextProps.workflow.currentStep != this.props.workflow.currentStep || !nextProps.typeModelCollection) {

    // }
    let data = this.props.formValues ? nextProps.formValues : workflowData;
    let filters = [];
    filterConfig && filterConfig.filters && filterConfig.filters.map(f => {
      const field = f.filterField && f.filterField.replace('{{', '').replace('}}', '');
      const value = ModelPropertiesParser(f.filterValueField, data);
      value && filters.push({ filterField: field, filterValue: [value], valueType: f.leafType })
    })
    let filterChange = false;
    const stateFilter = this.state.filter;
    if (stateFilter.length == 0) {
      filterChange = true;
    } else if (filters.length != stateFilter.length) {
      filterChange = true;
    } else {
      filters.map((item, i) => {
        if (item.filterValue[0] != stateFilter[i].filterValue[0]) {
          filterChange = true;
          return;
        }
      }
      );
    }
    
    if ((filterChange && filters.length > 0 && this.state.callCounter === 0 && loadFilteredDataFromServer) ||
      nextProps.pageSize != this.props.pageSize || nextProps.paginationStart != this.props.paginationStart) {
      this.setState({ callCounter: 1 }, () => {
        !isWorkflowCard && getModelByNamePromise({ name: customModelName }).then((res) => {
          const model = res.data;
          const typeId = model.id;
          let recieveFields = ['id'];
            if(recieveFieldsExtras) {
              const splits = recieveFieldsExtras.split(',');
              recieveFields = recieveFields.concat(splits);
            }
            if(modelSelector) {
               const expression = new RegExp(/\{\{(.*?)\}\}/g);
                const val = modelSelector.replace(expression, (pattr, matched) => {
                  recieveFields.push(matched);
                })
            }
            if(tableConfig && tableConfig.config && tableConfig.config.columns) {
              const columns = tableConfig.config.columns;
              Array.isArray(columns) && columns.map((column, i) => {
                if(column.config && column.config.flyoutField  ) {
                const expression = new RegExp(/\{\{(.*?)\}\}/g);
                const val = column.config.flyoutField.replace(expression, (pattr, matched) => {
                      const columnKey = column.field.classProperty;
                  if(column.field.type === 'TYPE' && !columnKey.startsWith("$$SELF$$")){

                    const base = columnKey.replace(/[{}]/g, '');       // "funder"
                    const prop = matched.replace(/[{}]/g, '');         // "fundername"
                    const result = `${base}.${prop}`;              // "{{funder.fundername}}"
                    console.log(result)
                      recieveFields.push(result);
                  }else{
                    console.log(matched)
                    recieveFields.push(matched);
                  }
                })
              } else if(column.config &&  column.config.modelSelector ) {
                console.log("-====")
                const expression = new RegExp(/\{\{(.*?)\}\}/g);
                const val = column.config.modelSelector.replace(expression, (pattr, matched) => {
                  const columnKey = column.field.classProperty;
                  if(column.field.type === 'TYPE' && !columnKey.startsWith("$$SELF$$")){

                    const base = columnKey.replace(/[{}]/g, '');       // "funder"
                    const prop = matched.replace(/[{}]/g, '');         // "fundername"
                    const result = `${base}.${prop}`;              // "{{funder.fundername}}"
                    console.log(result)
                      recieveFields.push(result);
                  }else{
                    console.log(matched)
                    recieveFields.push(matched);
                  }
                
                })
              } else {
                console.log(column.field.classProperty)
                recieveFields.push(column.field.classProperty)
              }
              })  
            }
            const payload = {
              customModelName: customModelName,
              typeId,
              customerName,
              filters,
              workflow: {
                id: workflow.id,
                displayMode: workflow.displayMode,
                // workflowSession: workflow.sessionId
              },
              isBase,
              "count": (readOnlyTableWithSelection || readOnlyTable) ? nextProps.pageSize : 10000,
              "start": (readOnlyTableWithSelection || readOnlyTable) ? nextProps.paginationStart : 0
            }
            if(recieveFields.length > 1 && !disbableOptimize) {
              payload['recieveFields'] = recieveFields;
            }
          if((filterChange && filters.length > 0 && this.state.callCounter === 0 && loadFilteredDataFromServer)){
            global['filterChanged']=true;
            this.props.change(classProperty,[])
          }
          this.props.readAll(payload, containerIndex, columnIndex);
          this.setState({ model, callCounter: 0, filter: filters, showLoading: false });
        });
      })

    }
  }

  setInitialValue = (initialValues, classProperty, modelSelector, change, hasModifiedClassProperty, replaceClassProperty) => {
    if (!this.state.isInitialValueSet) {
      const actualValue = resolvePath(hasModifiedClassProperty ? replaceClassProperty : classProperty, initialValues);
      if (Array.isArray(actualValue) && actualValue) {
        const values = actualValue;
        const initValues = initialValues[hasModifiedClassProperty ? replaceClassProperty : classProperty];
        initValues && initValues.map((item, itemIndex) => {
          if (!item.label) {
            values[itemIndex] = {
              label: ModelPropertiesParser(modelSelector, item),
              value: item.id,
              ...item
            }
          } else {
            values[itemIndex] = item;
          }
        })
        this.setState({
          isInitialValueSet: true
        }, () => {
          change(hasModifiedClassProperty ? replaceClassProperty : classProperty, values);
        })
      } else if (actualValue) {

        const value = {
          value: actualValue.id,
          label: ModelPropertiesParser(modelSelector, actualValue),
          ...actualValue
        }
        this.setState({
          isInitialValueSet: true
        }, () => {
          try {
            change(hasModifiedClassProperty ? replaceClassProperty : classProperty, value);
          }
          catch (ex) {
            console.log('ex..', ex);
          }
        })

      }
    }

  }

  handleSwap = (e) => {
     e.preventDefault();

     const {layoutItem:{itemProperties:{sourceProperty,replaceClassProperty}}} = this.props

     let sourceProp = sourceProperty;
      sourceProp = sourceProp.replace(/[{}]/g, ""); //to remove {{}}
    
 
 
  
        const sourceValue = this.props.formValues[sourceProp];
        const destValue = this.props.formValues[replaceClassProperty];

        // Now swap them using change()
        this.props.change(sourceProp, destValue);
        this.props.change(replaceClassProperty, sourceValue);
};

  render() {
    const { layoutItem, initialValues, isLayoutItemEditable, validations, readAll, isEditing, customerName, change, value, isReadOne, workflowData, customIcons, ...rest } = this.props;
    let { typeModelCollection, itemClassPropertyFromTable } = this.props;
    const { itemProperties } = layoutItem;
    const showAsRadioButton = itemProperties && itemProperties.showAsRadioButton
    const optionDisplayType = itemProperties && itemProperties.optionDisplayType ? itemProperties.optionDisplayType.value : null;
    let { modelSelector, typeModelViewMode, badgeType, placeholder, label, tableConfig, readOnlyTableWithSelection, readOnlyTable,
      field: { collection, classProperty, properties, customModelName }, replaceClassProperty ,enableSwapOfOneToOne,sourceProperty} = itemProperties
    let TypeCollectionData = null;
    if (itemProperties.parentModelSelector && !isLayoutItemEditable) {
      let data = this.props.formValues ? this.props.formValues : workflowData;
      if (!data) {
        data = workflowData ? workflowData : this.props.formValues;
        if (data == null)
          return null;
      }
      const wData = ModelPropertiesParser(itemProperties.parentModelSelector, data);

      if (wData)
        TypeCollectionData = { data: JSON.parse(wData) };
    } else {
      const { model } = this.state;

      if (!typeModelCollection && model && workflowData && workflowData[classProperty]) {
        console.log(typeModelCollection, model.name, workflowData[classProperty])
        const typeId = model.id;
        typeModelCollection = {};
        typeModelCollection[model.name] = workflowData[classProperty]
      }

      if (!model && !typeModelCollection && workflowData && workflowData[classProperty]) {
        typeModelCollection = {}
        typeModelCollection[customModelName] = workflowData[classProperty];
        TypeCollectionData = typeModelCollection;
      }
      if(!typeModelCollection && typeModelViewMode && typeModelViewMode.value === TypeModelDisplays.TABLE.value){
        typeModelCollection = []
      }
      if (!layoutItem || !typeModelCollection) return null;

      TypeCollectionData = typeModelCollection;
    }
    
    if (!TypeCollectionData) return null;
    if (TypeCollectionData && TypeCollectionData.isLoading === true || this.state.showLoading) return <p className='text-muted'>Loading...</p>;
    const placeholderText = placeholder.show ? placeholder.text : '';
    if (!typeModelViewMode || isEditing) {
      typeModelViewMode = TypeModelDisplays.DROPDOWN;
    }
    const hasModifiedClassProperty = replaceClassProperty && typeof replaceClassProperty === 'string' && replaceClassProperty !== '' ? true : false;
    typeModelCollection = TypeCollectionData.data;
    if (itemProperties.filterField && itemProperties.filterValueField) {
      let data = this.props.formValues ? this.props.formValues : workflowData;

      const tmpReplaceClassProperty = hasModifiedClassProperty ? replaceClassProperty.split('.') : '';
      const replaceString = itemProperties.filterValueField.substring(0, itemProperties.filterValueField.indexOf('.'));
      const tmpFilterVal = hasModifiedClassProperty ? itemProperties.filterValueField.replace(replaceString, `{{${tmpReplaceClassProperty[0]}`)
        : itemProperties.filterValueField;

      const filterData = ModelPropertiesParserArray(tmpFilterVal, data);
      let filteredCollection = [];
      typeModelCollection && typeModelCollection.forEach(x => {
        const currentFilterData = ModelPropertiesParser(itemProperties.filterField, x);
        if (Array.isArray(filterData)) {
          const f = filterData.find(v => v == currentFilterData);
          if (f)
            filteredCollection.push(x);
        } else {
          if (currentFilterData == filterData)
            filteredCollection.push(x);
        }
      });
      typeModelCollection = filteredCollection;
    }

    if (typeModelViewMode.value === TypeModelDisplays.DROPDOWN.value || typeModelViewMode.value === TypeModelDisplays.CHECKBOX.value) {
      let selectOptions = typeModelCollection && typeModelCollection.map((item) => {
        return {
          label: ModelPropertiesParser(modelSelector, item),
          value: item.id,
          ...item
        }
      });

      if (this.props.filterFieldForUniqueCheck) {
        const classPropertySelected = this.props.classProperty;
        const selectedData = this.props.formValues ? getNewContext(this.props.formValues, classPropertySelected) : null;
        const mainClassProperty = classPropertySelected.split('[')[0]
        const data = getNewContext(this.props.formValues, mainClassProperty)
        const itemClassPropertyFromTable = this.props.itemClassPropertyFromTable
        data && data.map((formData) => {
          const selectedData = formData ? getNewContext(formData, itemClassPropertyFromTable) : null;
          const selectedData2 = formData[itemClassPropertyFromTable];
          selectOptions = selectOptions.filter(item => {

            if (item && selectedData && item.id === selectedData.id) {
              return false
            }
            return true
          })
        })
      }

      if (this.props.columns &&
        this.props.columns[`${this.props.colIndex}`] &&
        this.props.columns[`${this.props.colIndex}`].config &&
        this.props.columns[`${this.props.colIndex}`].config.customOneToManyRemovePrevDropdown &&
        this.props.columns[`${this.props.colIndex}`].config.updateEnableRemovePrevDropdown
      ) {

        const customOneToManyRemovePrevDropdown = this.props.columns &&
          this.props.columns[`${this.props.colIndex}`] &&
          this.props.columns[`${this.props.colIndex}`].config &&
          this.props.columns[`${this.props.colIndex}`].config.customOneToManyRemovePrevDropdown ?
          this.props.columns[`${this.props.colIndex}`].config.customOneToManyRemovePrevDropdown
          :
          ""
        const removeBrackets = this.props.columns[`${this.props.colIndex}`].config.customOneToManyRemovePrevDropdown.replace("{{", "").replace("}}", "");


        const getNestedValue = (path) => {
          return path.split('.').reduce((acc, part) => acc && acc[part], this.props.formValues && this.props.formValues[`${this.props.parentClassProperty}`] ? this.props.formValues[`${this.props.parentClassProperty}`][`${this.props.currentIndex}`] : []);
        };
        const stopName = getNestedValue(`${removeBrackets}`);

        const filteredArray = selectOptions.filter(item => item.label === `${stopName}`);
        const storeFIlterDataId = filteredArray && filteredArray[0] && filteredArray[0].id ? filteredArray[0].id : null
        const filteredOptions = selectOptions.filter(item => item.id > storeFIlterDataId);
        selectOptions = filteredOptions

      }


      this.setInitialValue(initialValues, classProperty, modelSelector, change, hasModifiedClassProperty, replaceClassProperty);

      if(enableSwapOfOneToOne){
                  return( <div
                    className='mainDivSwap'
                    style={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px' // space between button and select
            }}>
                  <button
                  className='buttonSwap'
            onClick={this.handleSwap}
            style={{
              backgroundColor: '#e0e0e0',
              border: 'none',
              padding: '10px',
              borderRadius: '50%',
              cursor: 'pointer',
              fontSize: '20px'
            }}
            title="Swap Source and Destination"
          >
            <i className="fa fa-exchange iconSwap"></i>
          </button>
           <Field
            name={hasModifiedClassProperty ? replaceClassProperty : classProperty}
            component={renderSelectAnotherType}
            type="select"
            validate={validations}
            normalize={(val) => {
              let newVal = val;
              if (newVal && newVal.class && newVal.class.indexOf('LinkedTreeMap') != -1) {
                newVal.class = newVal.serializerClass;
              }
              // if(Array.isArray(newVal)) {
              //   newVal.map((v,i) => {
              //     newVal[i] = {
              //       class: v.class,
              //       id: v.id,
              //       label: v.label,
              //       value: v.value
              //     }
              //   })
              //   return newVal
              // }
              return newVal
            }}
            fieldType='TYPE'
            valueKey='value'
            labelKey='label'
            options={!selectOptions ? [] : selectOptions}
            showAsRadioButton={showAsRadioButton}
            optionDisplayType={optionDisplayType}
            properties={properties}
            initialValues={initialValues}
            change={change}
            {...rest}
            multiple={collection}
            customModelSelector={modelSelector}
            layoutItem={layoutItem}
          />
        </div>)
       
      }

      return (
        typeModelViewMode.value === TypeModelDisplays.DROPDOWN.value ?
          <Field
            name={hasModifiedClassProperty ? replaceClassProperty : classProperty}
            component={renderSelectAnotherType}
            type="select"
            validate={validations}
            normalize={(val) => {
              let newVal = val;
              if (newVal && newVal.class && newVal.class.indexOf('LinkedTreeMap') != -1) {
                newVal.class = newVal.serializerClass;
              }
              // if(Array.isArray(newVal)) {
              //   newVal.map((v,i) => {
              //     newVal[i] = {
              //       class: v.class,
              //       id: v.id,
              //       label: v.label,
              //       value: v.value
              //     }
              //   })
              //   return newVal
              // }
              return newVal
            }}
            fieldType='TYPE'
            valueKey='value'
            labelKey='label'
            options={!selectOptions ? [] : selectOptions}
            showAsRadioButton={showAsRadioButton}
            optionDisplayType={optionDisplayType}
            properties={properties}
            initialValues={initialValues}
            change={change}
            {...rest}
            multiple={collection}
            customModelSelector={modelSelector}
            layoutItem={layoutItem}
            disabled={ this.props.disableLayoutItem }
          /> : <div className="type-model-collection-checkbox-container d-flex">
            {
              layoutItem && layoutItem.itemProperties && layoutItem.itemProperties.beforeIcon ?
                <span className="mr-2"><RenderIcon config={layoutItem.itemProperties.beforeIcon} customIcons={customIcons} /></span> : null
            }
            <Field
              name={classProperty}
              component={renderMultipleCheckBox}
              type="checkbox"
              validate={validations}
              fieldType='checkbox'
              valueKey='id'
              labelKey='label'
              options={selectOptions}
              customIcons={customIcons}
              properties={properties}
              initialValues={initialValues}
              layoutItem={layoutItem}
              {...rest}
              multiple={collection}
              customModelSelector={modelSelector}
            /></div>
      )
    }
    if (typeModelViewMode.value === TypeModelDisplays.TABLE.value) {
      const rows = (workflowData && hasModifiedClassProperty) ? getNewContext(workflowData, replaceClassProperty) : workflowData ? workflowData[classProperty] : [];
      const list1 = typeModelCollection ? new DataListStore(typeModelCollection) : new DataListStore([]);
      const sorting = {
        order: 'ASCENDING'
      }
      
      const tableRows = readOnlyTableWithSelection
        ? (rows ? new DataListStore(rows) : list1)
        : readOnlyTable
          ? new DataListStore(rows || [])
          : list1;
      
      if (readOnlyTableWithSelection || readOnlyTable) {
        const size = {};
        return <div><TABLE
          size={size}
          workflow={this.props.workflow}
          //rows={readOnlyTable ? rows ? new DataListStore(rows) : new DataListStore() : list1} //old
          rows={tableRows}
          columns={tableConfig.config.columns}
          user={this.props.user}
          selectedTemplate='TEMPLATE_ONE'
          dateformat=""
          pageSize={this.props.pageSize}
          sorting={sorting}
          changeVal={change}
          readOnlyTableWithSelection={readOnlyTableWithSelection}
          name={hasModifiedClassProperty ? replaceClassProperty : classProperty}
          formValues={this.props.formValues}
          hasModifiedClassProperty={hasModifiedClassProperty}
          getNewContext={getNewContext}
          readOnlyTable={readOnlyTable}
          totalCount={TypeCollectionData.totalCount}
        />
          <Pagination
            start={this.props.paginationStart}
            hasNextPage={typeModelCollection ? typeModelCollection.length === this.props.pageSize : false}
            size={this.props.pageSize}
            onChangePage={this.props.onChangePage}
            onChangePageSize={this.props.onChangePageSize}
            totalCount={TypeCollectionData.totalCount}
          />
        </div>

      }
      return <TypeModelCreateUpdateTable
        label={label}
        workflow={this.props.workflow}
        rows={rows ? rows : []}
        columns={tableConfig.config.columns}
        layoutItem={layoutItem}
        validations={validations}
        {...this.props}
      />
    }

    if (typeModelViewMode.value === TypeModelDisplays.BADGES.value) {
      return <TypeModelBadges
        label={label}
        workflow={this.props.workflow}
        workflowData={workflowData}
        badgeType={badgeType}
        layoutItem={layoutItem}
        modelSelector={modelSelector}
      />
    }
    if (typeModelViewMode.value === TypeModelDisplays.WORKFLOWCARD.value) {
      const rows = hasModifiedClassProperty ? getNewContext(workflowData, replaceClassProperty) : workflowData ? workflowData[classProperty] : [];
      return (
        <TypeModelCreateUpdateWorkflowCard
          rows={rows}
          classProperty={this.props.classProperty}
          readOneWorkflowUniqueCode={itemProperties.readOneWorkflowUniqueCode}
        />
      )
    }
  }
}

const mapStateToProps = (state, ownProps) => {
  const { workflow, containerIndex, columnIndex, layoutItem: { itemProperties: { field: { classProperty, customModelName, customTypeId } } } } = ownProps;
  const newState = state.toJS();
  const modelProp = customModelName ? customModelName : customTypeId;
  let typeModelCollection = null;
  if (typeof workflow.collections !== 'undefined' && workflow.collections !== null) {
    // typeModelCollection = workflow.collections[workflow.sessionId+'_'+modelProp + `_c${containerIndex}_${columnIndex}`];
    typeModelCollection = workflow.collections[modelProp + `_c${containerIndex}_${columnIndex}`];
    if (!typeModelCollection) {
      // typeModelCollection = workflow.collections[workflow.sessionId+'_'+modelProp + `_c${containerIndex}`];
      typeModelCollection = workflow.collections[modelProp + `_c${containerIndex}`];
    }
  }
  return {
    typeModelCollection,
    customerName: workflow.currentItem.typeModel.customerName
  }
};
const mapDispatchToProps = (dispatch) => {
  return {
    readAll: (payload, containerId, columnId) => {
      dispatch(readAll(payload, 'c' + containerId, columnId));
    },
    getModelByNamePromise: (payload) => {
      return dispatch(getModelByNamePromise(payload));
    }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(toJS(TypeModelCreateUpdate));

